// App.tsx — Raíz con ThemeProvider + LanguageProvider + ToastProvider + AuthProvider
import { Routes, Route, Navigate } from 'react-router-dom';
import { Header } from '@/marketing/components/Header/Header';
import { Footer } from '@/marketing/components/Footer/Footer';
import { ToastProvider } from '@/shared/context/ToastContext';
import { ThemeProvider } from '@/shared/context/ThemeContext';
import { LanguageProvider } from '@/shared/context/LanguageContext';
import { AuthProvider } from '@/shared/context/AuthContext';
import { ToastContainer } from '@/shared/ui/Toast/Toast';
import { ProtectedRoute } from './components/ProtectedRoute/ProtectedRoute';
import LandingPage from '@/marketing/pages/LandingPage';
import LeadsPage from './pages/LeadsPage';
import InterviewPracticePage from './pages/InterviewPracticePage';
import ResourceViewerPage from './pages/ResourceViewerPage';
import DialoguePracticePage from './pages/DialoguePracticePage';
import MonologuePracticePage from './pages/MonologuePracticePage';
import QAPracticePage from './pages/QAPracticePage';
import PrepSupportEngineerPage from './pages/PrepSupportEngineerPage';
import TurnstileGate from '@/shared/ui/TurnstileGate/TurnstileGate';
import styles from './App.module.css';


const App = () => (
  <ThemeProvider>
      <TurnstileGate>

  <LanguageProvider>
    <AuthProvider>
      <ToastProvider>
        {/* appShell: columna flex de altura mínima 100vh — appMain crece
            con flex:1 para empujar el Footer hasta el fondo de la
            ventana cuando la página tiene poco contenido, y simplemente
            se desplaza con el contenido cuando este crece (ej. el
            dashboard con el sidebar expandido). Ver App.module.css. */}
        <div className={styles.appShell}>
        <Header />
        <div className={styles.appMain}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/quienes-somos" element={<div style={{ padding: '8rem 2rem', color: 'var(--text-secondary)' }}>Página en construcción</div>} />
          <Route path="/contacto" element={<div style={{ padding: '8rem 2rem', color: 'var(--text-secondary)' }}>Página en construcción</div>} />
          {/* /dashboard ya no tiene página propia — redirige a Leads, la
              única sección del panel, por si alguien tenía esa URL guardada. */}
          <Route path="/dashboard" element={<Navigate to="/dashboard/leads" replace />} />
          <Route
            path="/dashboard/leads"
            element={
              <ProtectedRoute>
                <LeadsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/entrevista"
            element={
              <ProtectedRoute>
                <InterviewPracticePage />
              </ProtectedRoute>
            }
          />
          {/* Documentos estáticos (CVs, guías backend, tests psicológicos,
              ofertas) — todos comparten el mismo visor por :slug. */}
          <Route
            path="/dashboard/recursos/:slug"
            element={
              <ProtectedRoute>
                <ResourceViewerPage />
              </ProtectedRoute>
            }
          />
          {/* Diálogos bilingües de práctica (inglés/español) — un solo
              visor genérico por :slug, ver src/data/dialogues.ts. */}
          <Route
            path="/dashboard/practica/:slug"
            element={
              <ProtectedRoute>
                <DialoguePracticePage />
              </ProtectedRoute>
            }
          />
          {/* Discursos de un solo hablante (ej. Elevator Pitch). */}
          <Route
            path="/dashboard/pitch/:slug"
            element={
              <ProtectedRoute>
                <MonologuePracticePage />
              </ProtectedRoute>
            }
          />
          {/* Guiones de preguntas frecuentes con respuesta modelo. */}
          <Route
            path="/dashboard/guion/:slug"
            element={
              <ProtectedRoute>
                <QAPracticePage />
              </ProtectedRoute>
            }
          />
          {/* Página dedicada — análisis + diálogo + Q&A para una vacante
              específica (Application Support Engineer .NET/K8s/AWS). */}
          <Route
            path="/dashboard/prep/support-engineer"
            element={
              <ProtectedRoute>
                <PrepSupportEngineerPage />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={
            <div style={{ padding: '8rem 2rem', textAlign: 'center', color: 'var(--text-secondary)' }}>
              <h1 style={{ fontSize: '3.5rem', color: 'var(--brand-accent)' }}>404</h1>
              <p>Página no encontrada</p>
              <a href="/" style={{ color: 'var(--brand-accent)', marginTop: '1rem', display: 'inline-block' }}>Volver al inicio</a>
            </div>
          } />
        </Routes>
        </div>
        <Footer />
        </div>
        <ToastContainer />
      </ToastProvider>
    </AuthProvider>
  </LanguageProvider>
  </TurnstileGate>
  </ThemeProvider>
);

export default App;
